export class FaxRxComposite {
    public PharmacyName: string;
    public PharmacyBanner: string;
    public PharmacyPhone: string;
    public PharmacyFax: string;
    public PharmacyAddress: string;

    public constructor(init?: Partial<FaxRxComposite>) {
        Object.assign(this, init);
    }
}
